import * as React from 'react';
import { useTranslation } from 'react-i18next';

enum SizeUnit {
  BYTES = 'BYTES',
  KB = 'KB',
  MB = 'MB',
  GB = 'GB',
  TB = 'TB',
}

const sizeInUnits = (fileSize: number) => {
  let size = Math.abs(fileSize);

  if (size === 0) {
    return {
      size: 0,
      unit: SizeUnit.BYTES,
    };
  }

  const units = [SizeUnit.BYTES, SizeUnit.KB, SizeUnit.MB, SizeUnit.GB, SizeUnit.TB];
  const index = Math.floor(Math.log(size) / Math.log(1024));
  const formattedSize = size / Math.pow(1024, index);

  return { size: formattedSize, unit: units[index] };
};

export const useFileSize = () => {
  const { t } = useTranslation();
  const format = React.useCallback(
    (size: number) => {
      const fileSize = sizeInUnits(size);

      return t(`FORMAT_SIZE.UNITS.${fileSize.unit}`, { size: fileSize.size.toFixed(2) });
    },
    [t],
  );

  return format;
};
